import { useNameField } from '@/features/settings/components/PrinterConfiguration/form'
import LabeledInputField from '@/features/settings/components/forms/LabeledInputField'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const NameField: FC = () => {
    const { t } = useTranslation()

    const [value, onChange] = useNameField()

    return (
        <LabeledInputField
            value={value}
            onChange={onChange}
            label={t('settings.printers.printerConfiguration.field.name.label')}
        />
    )
}

export default NameField
